/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import template from './trigger-form.component.html';
import {APP_SHARED} from '../common/app-shared';
import {AdnSelectComponent} from '../common/directives/adn-select/adn-select.component';
import {FORM_CONTROLS} from '../common/directives/form-controls/form-controls';
import {MATCHING_STYLES, SPECIAL_BEHAVIOUR_DOMAIN_TYPES, TriggerFormLogic} from './trigger-form-logic';

@Component({
  standalone: true,
  imports: [
    ...APP_SHARED,
    FormsModule,
    ButtonsModule,
    BsDatepickerModule,
    AdnSelectComponent,
    ...FORM_CONTROLS
  ],
  selector: 'adn-trigger-form',
  template
})
export class TriggerFormComponent {
  @Input() logic: TriggerFormLogic;

  @Output() changed = new EventEmitter<void>();

  readonly matchingStyles = MATCHING_STYLES;
  readonly specialBehaviourDomainTypes = SPECIAL_BEHAVIOUR_DOMAIN_TYPES;
  readonly datePickerConfig = {
    dateInputFormat: 'YYYY-MM-DD',
    containerClass: 'theme-blue',
    showWeekNumbers: false,
    adaptivePosition: true
  };

  getOperationHelp(criterion: any): string {
    const fieldName = criterion?.name;
    const operationId = criterion?.operation?.id;
    if (!fieldName || !operationId) {
      return '';
    }
    return this.logic?.nameOpHelp?.[fieldName]?.[operationId] || '';
  }
}
